export default "__VITE_ASSET__D3q_HV39__"